module.exports = __webpack_public_path__ + "img/img_yiduihuan@2x.1345decf.png";